<!-- 电站管理 -->

<script setup></script>

<template>
  <div id="user">
    <button-router></button-router>

    <router-view v-slot="{ Component }">
      <!-- <keep-alive> -->
      <component :is="Component"></component>
      <!-- </keep-alive> -->
    </router-view>
  </div>
</template>

<style lang="scss" scoped>
#user {
  height: 100%;
}
</style>
